import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MDSCprofileEditor.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import Edit from '../../moreCore/UI/Edit/Edit';
import lang from 'dojo/_base/lang';

class MDSCprofileEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private explainerSpan:HTMLSpanElement;
    private dlg:MdsLax<InstanceType<typeof GenericDialog>>;
    private loadingContainer:HTMLDivElement;
    private table:MdsLax<InstanceType<typeof StaticTable>>;
    private tableContainer:HTMLDivElement;

    private addNewEntryBtn:HTMLButtonElement;

    private entryInput: Array<MdsLax<InstanceType<typeof Edit>>> = [];

    private mainData: Array<{ ID: string, identifierStr:string }> = [];
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.explainerSpan.innerHTML = this.translate("MDSConnect_ProfileMenu_ExplainerTxt");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    showDlg(){
        if (typeof this.dlg == 'undefined'){
            this.dlg = new GenericDialog();
        }else{
            try{
                this.dlg.destroy();
            }catch{}
            this.dlg = new GenericDialog();
            for (let edit of this.entryInput){
                try{
                    edit.destroy();
                }catch{}
            }
            this.entryInput = [];
        }
        this.dlg.destroyOnClose = true;
        this.dlg.closeOnEnter = false;
        this.dlg.closeOnEscape = false;
        this.dlg.show(
            this,
            this.translate("MDSConnect_ProfileMenu_Title"),
            null,
            null,
            "close",
            null,
            null
        );
        this.updateDisplayData();
    }

    private updateDisplayData(){
        this.StandbyStart(this.loadingContainer);
        this.RequestManager.callfunction(
            "Webtool_API_MDSConnect__GetUserData",
            {},
            (resp: { identifiers:Array<any>})=>{
                this.StandbyStop();
                this.mainData = resp.identifiers;
                this.mainData = this.mainData.sort((a, b) => {
                    return a.ID.localeCompare(b.ID);
                });
                this.render_table();
            },
            (err:more.requestErrorMessage)=>{
                this.StandbyStop();
                console.error(err);
                this.showToast(err.Message, "fas fa-exclamation-circle");
            }
        );
    }

    private render_table(){
        let oldHight = this.tableContainer.style.minHeight;
        this.tableContainer.style.minHeight = this.tableContainer.getBoundingClientRect().height + "px";
        if (typeof this.table != 'undefined'){
            try{
                this.table.destroy();
            }catch{}
            this.tableContainer.innerHTML = "";
        }
        this.table = new StaticTable();
        this.table.placeAt(this.tableContainer);
        this.table.setLayout(
            {
                rows: [
                    {
                        attributes: [
                            "identifierStr",
                        ],
                        headings: [
                            this.translations["MDSConnect_ProfileMenu_TableHeader"],
                        ],
                        colspans: [
                            1
                        ],
                        widths: [
                            null
                        ],
                        colNamesInternal: [
                            "identifierStr"
                        ],
                        bgColors: [
                            ""
                        ],
                        txtColors: [
                            ""
                        ]
                    }
                ],
                name: "default",
                label: "Standard"
            }
        );
        this.table.addCustomRowActionButton("Remove", lang.hitch(this, this.onClick_DeleteRowBtn), "far fa-trash-alt warningTXT");
        this.table.setFormatter(lang.hitch(this, this.tableFormatter));
        this.table.setData(this.mainData);
        this.table.setCyAttribute("MDSCprofileEditorTable");
        this.tableContainer.style.minHeight = oldHight;
        if (this.mainData.some((val) => { if (val.ID == "new") { return true; } else { return false; } })) {
            //new entry btn disabled
            this.addNewEntryBtn.disabled = true;
            this.addNewEntryBtn.classList.add("disabled", "w3-disabled");
            this.addNewEntryBtn.title = this.translate("MDSConnect_ProfileMenu_HintNewEntryBtnDisabled");
        }else{
            this.addNewEntryBtn.disabled = false;
            this.addNewEntryBtn.classList.remove("disabled", "w3-disabled");
            this.addNewEntryBtn.removeAttribute("title");
        }
    }

    private tableFormatter(cell: StaticTable.StaticTableCell<any>):boolean{
        if (cell.name == "identifierStr"){
            let identifierStr:string = cell.entity["identifierStr"];
            let id:string = cell.entity["ID"];
            cell.contentnode.innerHTML = "";
            cell.value = " ";
            let identifierEdit = new Edit();
            identifierEdit.setIsMultiline(false);
            identifierEdit.setValue(identifierStr, true);
            identifierEdit.on("change", lang.hitch(this, (changeVal:string)=>{
                identifierEdit.setReadonly(true);
                this.onChange_Input(id, changeVal);
                identifierEdit.setReadonly(false);
            }));
            let container = document.createElement('div');
            cell.contentnode.appendChild(container);
            identifierEdit.placeAt(container);
            if (id == "new"){
                container.classList.add("warningBorder");
                try{
                    identifierEdit.focus();
                }catch{}
            }
            return true;
        }
        return false;
    }

    private onClick_DeleteRowBtn(rowGroup: StaticTable.StaticTableRowGroup<any>){
        let id = rowGroup.entity["ID"];
        if (id == "new"){
            this.updateDisplayData();
            return;
        }
        this.deleteEntry(id);
    }
    private deleteEntry(id:string){
        this.StandbyStart(this.loadingContainer);
        this.RequestManager.callfunction(
            "Webtool_API_MDSConnect__RemoveProfileIdentifier",
            { ID: id },
            () => {
                this.StandbyStop();
                this.updateDisplayData();
            },
            (err) => {
                this.StandbyStop();
                console.error(err);
                this.showToast(err.Message, "fas fa-exclamation-circle");
                this.updateDisplayData();
            }
        );
    }

    private onChange_Input(id:string, newVal:string){
        newVal = newVal.trim();
        if (newVal == ""){
            if (id != "new"){
                this.deleteEntry(id);
            }
            return;
        }
        this.StandbyStart(this.loadingContainer);
        if (id != "new"){
            this.RequestManager.callfunction(
                "Webtool_API_MDSConnect__EditProfileIdentifier",
                { ID: id, identifier:newVal},
                (resp: { wasNotDuplicate:boolean })=>{
                    this.StandbyStop();
                    if (resp.wasNotDuplicate){
                        this.updateDisplayData();
                    }else{
                        this.showToast(this.translate("MDSConnect_ProfileMenu_Dublicate"), "fas fa-key");
                        this.updateDisplayData();
                    }
                },
                (err) => {
                    this.StandbyStop();
                    console.error(err);
                    this.showToast(err.Message, "fas fa-exclamation-circle");
                    this.updateDisplayData();
                }
            );
        }else{
            this.RequestManager.callfunction(
                "Webtool_API_MDSConnect__AddProfileIdentifier",
                { identifier:newVal},
                (resp: { ID: string, wasNotDuplicate:boolean })=>{
                    this.StandbyStop();
                    if (resp.wasNotDuplicate == false){
                        this.showToast(this.translate("MDSConnect_ProfileMenu_Dublicate"), "fas fa-key");
                        //nicht table updaten, da ansonsten dann der new eintrag rausfliegt
                    }else{
                        this.updateDisplayData();
                    }
                },
                (err) => {
                    this.StandbyStop();
                    console.error(err);
                    this.showToast(err.Message, "fas fa-exclamation-circle");
                    this.updateDisplayData();
                }
            );
        }
    }

    private _onClick_NewEntry(ev:Event){
        if (!this.mainData.some((val) => { if (val.ID == "new") { return true; } else { return false; } })){
            this.mainData.push({ID:"new", identifierStr:""});
        }
        this.render_table();
    }
}

export default mdsWidget(MDSCprofileEditor);
